import { useMemo, useState } from "react";

const socialLinks = [
  {
    id: "instagram",
    title: "China In Iraq",
    link: "https://www.instagram.com/china.in.iraq/",
    icon: "ci-instagram",
    iconClass: "text-danger",
  },
  {
    id: "facebook",
    title: "China Stars",
    link: "https://www.facebook.com/@chinastars.iq/?mibextid",
    icon: "ci-facebook",
    iconClass: "text-primary",
  },
  {
    id: "kids-clothes",
    title: "ملابس الاطفال",
    whatsapp: "https://www.whatsapp.com/channel/0029Vb7Jb3F9hXF1XRax2u0i",
    telegram: "https://t.me/china_stars",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "baby-needs",
    title: "احتياجات بيبي",
    whatsapp: "https://www.whatsapp.com/channel/0029VbClQcq4yltSb2QCyw2z",
    telegram: "https://t.me/ChinastarsBaby",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "kids-women-accessories",
    title: "اكسسوارات اطفال و النساء",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCW16ODp2Q7TSr5LS03",
    telegram: "https://t.me/ChinastarsAccessories",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "women-clothes",
    title: "ملابس نسائية",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCrxb61CYoYdjZWE225",
    telegram: "https://t.me/Chinastars_women",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "shoes",
    title: "الاحذية",
    whatsapp: "https://www.whatsapp.com/channel/0029VbDBllFIiRotNCYL7j1H",
    telegram: "https://t.me/chinastars0shose",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "socks-accessories",
    title: "جوارب والملحقات",
    whatsapp: "https://www.whatsapp.com/channel/0029Vb7wmUz3AzNQhHOIyP35",
    telegram: "https://t.me/ChinaStars1socks",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "electronics",
    title: "اليكترونيات",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCXCSjElah0nvIcp30F",
    telegram: "https://t.me/ChinastarsElictornics",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "toys",
    title: "الالعاب",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCSD6o8F2pEHhepf92b",
    telegram: "https://t.me/ChinaStarsToys",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "bags",
    title: "الحقائب",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCvABqIHphGjRG64t44",
    telegram: "https://t.me/ChinaSTARSStationery",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "thermos-cups",
    title: "ترمز و كوب",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCCe56GzzKUi776nM0b",
    telegram: "https://t.me/ChinaStarsThermosAndCup",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "home-textiles",
    title: "مفروشات",
    whatsapp: "https://www.whatsapp.com/channel/0029Vb7M2TM9hXFG24wKWM32",
    telegram: "https://t.me/chinastarscarpet",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "women-shawls",
    title: "شالات نسائية",
    whatsapp: "https://www.whatsapp.com/channel/0029Vb7zzELK5cD7fYxsXf3d",
    telegram: "https://t.me/ChinaStarshaj",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "medalia",
    title: "ميداليا",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCP2bV6buMQ5Ev44k1h",
    telegram: "https://t.me/ChinaStarsMadaliya",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "quran-pen",
    title: "قلم قران",
    whatsapp: "https://www.whatsapp.com/channel/0029Vb7n5U07z4kZdQp7mV1y",
    telegram: "https://t.me/ChinaStars_Quran",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "special-orders",
    title: "شى ئن للطلبات الخاصة",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCjYnGHLHQcakzDwK2a",
    telegram: "https://t.me/Chinastarsbabyclothes",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
  {
    id: "sea-shipping",
    title: "شحن البحري بالكوتينر والحوالات",
    whatsapp: "https://www.whatsapp.com/channel/0029VbCUeKs2975Dcmpzh82O",
    telegram: "https://t.me/ChinastarSseafreight",
    icon: "ci-telegram",
    iconClass: "text-secondary",
  },
];
const translations = {
  en: {
    title: "China Star Social Media",
    subtitle: "Connect with China Star across Telegram and WhatsApp channels.",
    telegram: "Telegram",
    whatsapp: "WhatsApp",
    browseTelegram: "Browse all Telegram channels",
    browseWhatsApp: "Browse all WhatsApp channels",
    back: "Back",
    open: "Open",
    openLink: "Open Link",
    explore: "Explore",
  },
  ar: {
    title: "وسائل التواصل الخاصة بـ China Star",
    subtitle: "تواصل مع China Star عبر قنوات تيليجرام وواتساب.",
    telegram: "تيليجرام",
    whatsapp: "واتساب",
    browseTelegram: "تصفح جميع قنوات تيليجرام",
    browseWhatsApp: "تصفح جميع قنوات واتساب",
    back: "رجوع",
    open: "فتح",
    openLink: "فتح الرابط",
    explore: "استكشاف",
  },
  ku: {
    title: "سۆشیال میدیای China Star",
    subtitle:
      "لە ڕێگەی کەناڵەکانی تێلیگرام و واتساپ پەیوەندی بە China Star بکە.",
    telegram: "تێلیگرام",
    whatsapp: "واتساپ",
    browseTelegram: "هەموو کەناڵەکانی تێلیگرام ببینە",
    browseWhatsApp: "هەموو کەناڵەکانی واتساپ ببینە",
    back: "گەڕانەوە",
    open: "کردنەوە",
    openLink: "کردنەوەی بەستەر",
    explore: "گەڕان",
  },
};

function Links() {
  const [activeTab, setActiveTab] = useState("");
  const [lang, setLang] = useState("ar");
  const t = translations[lang];

  const filteredLinks = useMemo(() => {
    if (activeTab === "telegram") {
      return socialLinks.filter((item) => item.telegram || item.link);
    }

    if (activeTab === "whatsapp") {
      return socialLinks.filter((item) => item.whatsapp || item.link);
    }

    return socialLinks;
  }, [activeTab]);

  const getHref = (item) => {
    if (activeTab === "telegram") {
      return item.telegram || item.link || "#";
    }

    if (activeTab === "whatsapp") {
      return item.whatsapp || item.link || "#";
    }

    return item.link || item.telegram || item.whatsapp || "#";
  };

  const getButtonLabel = (item) => {
    if (item.link) return "Open Link";
    if (activeTab === "telegram") return "Open Telegram";
    if (activeTab === "whatsapp") return "Open WhatsApp";
    return "Open";
  };

  const getTabIcon = (tab) => {
    if (tab === "telegram") return "ci-telegram";
    return "ci-whatsapp";
  };

  return (
    <>
      <div className="d-flex justify-content-center gap-2 mb-4 mt-4">
        <button
          className={`btn btn-sm ${lang === "en" ? "btn-dark" : "btn-outline-dark"}`}
          onClick={() => setLang("en")}
        >
          EN
        </button>
        <button
          className={`btn btn-sm ${lang === "ar" ? "btn-dark" : "btn-outline-dark"}`}
          onClick={() => setLang("ar")}
        >
          عربي
        </button>
        <button
          className={`btn btn-sm ${lang === "ku" ? "btn-dark" : "btn-outline-dark"}`}
          onClick={() => setLang("ku")}
        >
          کوردی
        </button>
      </div>
      <div className="container mt-4 mb-5" dir={lang === "en" ? "ltr" : "rtl"}>
        <div className="text-center mb-4">
          <h1 className="h3 mb-1">{t.title}</h1>
          <p className="text-muted">{t.subtitle}</p>
        </div>

        {!activeTab ? (
          <div className="row g-3 justify-content-center">
            <div className="col-12 col-sm-6 col-lg-4">
              <button
                type="button"
                onClick={() => setActiveTab("telegram")}
                className="w-100 border-0 bg-transparent p-0"
                style={{ appearance: "none", WebkitAppearance: "none" }}
              >
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    borderRadius: "20px",
                    transition: "all 0.25s ease",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
                  }}
                >
                  <div className="card-body py-5 px-4 text-center d-flex flex-column align-items-center">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                      style={{
                        width: 92,
                        height: 92,
                        background: "#0088CC",
                        border: "1px solid #0088CC",
                      }}
                    >
                      <i
                        className="ci-telegram"
                        style={{
                          marginRight: "2px",
                          fontSize: "2.4rem",
                          color: "white",
                        }}
                      />
                    </div>

                    <h2 className="h4 mb-2 fw-semibold">{t.telegram}</h2>
                    <p
                      className="text-muted mb-4"
                      style={{ maxWidth: "220px" }}
                    >
                      {t.browseTelegram}
                    </p>

                    <span
                      className="d-inline-flex align-items-center gap-2"
                      style={{
                        fontSize: "0.95rem",
                        color: "#006BA0",
                        fontWeight: "600",
                      }}
                    >
                      {t.explore}
                      <i
                        className="ci-arrow-right"
                        style={{
                          rotate:
                            lang === "ar" || lang === "ku" ? "180deg" : "0deg",
                        }}
                      />
                    </span>
                  </div>
                </div>
              </button>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <button
                type="button"
                onClick={() => setActiveTab("whatsapp")}
                className="w-100 border-0 bg-transparent p-0"
                style={{ appearance: "none", WebkitAppearance: "none" }}
              >
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    borderRadius: "20px",
                    transition: "all 0.25s ease",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #f8fffb 100%)",
                  }}
                >
                  <div className="card-body py-5 px-4 text-center d-flex flex-column align-items-center">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                      style={{
                        width: 92,
                        height: 92,
                        background: "rgba(25, 135, 84, 0.08)",
                        border: "1px solid rgba(25, 135, 84, 0.15)",
                      }}
                    >
                      <i
                        className="ci-whatsapp text-success"
                        style={{ fontSize: "2.2rem" }}
                      />
                    </div>

                    <h2 className="h4 mb-2 fw-semibold">{t.whatsapp}</h2>
                    <p
                      className="text-muted mb-4"
                      style={{ maxWidth: "220px" }}
                    >
                      {t.browseWhatsApp}
                    </p>

                    <span
                      className="d-inline-flex align-items-center gap-2 text-success"
                      style={{ fontSize: "0.95rem", fontWeight: "600" }}
                    >
                      {t.explore}
                      <i
                        className="ci-arrow-right"
                        style={{
                          rotate:
                            lang === "ar" || lang === "ku" ? "180deg" : "0deg",
                        }}
                      />
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex flex-column align-items-start mb-4 gap-2">
              <button
                type="button"
                className="btn back-btn"
                onClick={() => setActiveTab("")}
              >
                <i
                  className="ci-arrow-left"
                  style={{
                    rotate: lang === "ar" || lang === "ku" ? "180deg" : "0deg",
                    marginLeft: lang === "ar" || lang === "ku" ? "0.3rem" : "0",
                    marginRight:
                      lang === "ar" || lang === "ku" ? "0" : "0.3rem",
                  }}
                />
                {t.back}
              </button>

              <div
                className="btn-group align-self-center mt-2 gap-2"
                role="group"
                aria-label="Social tabs"
              >
                <button
                  type="button"
                  className={`btn ${
                    activeTab === "telegram"
                      ? "telegram-btn-active"
                      : "telegram-btn"
                  }`}
                  style={{
                    borderRadius: "4px",
                  }}
                  onClick={() => setActiveTab("telegram")}
                >
                  <i
                    className="ci-telegram me-2"
                    style={{
                      marginLeft:
                        lang === "ar" || lang === "ku" ? "0.3rem" : "0",
                      marginRight:
                        lang === "ar" || lang === "ku" ? "0" : "0.3rem",
                    }}
                  />
                  {t.telegram}
                </button>

                <button
                  type="button"
                  className={`btn ${
                    activeTab === "whatsapp"
                      ? "btn-success"
                      : "btn-outline-success"
                  }`}
                  style={{
                    borderRadius: "4px",
                  }}
                  onClick={() => setActiveTab("whatsapp")}
                >
                  <i
                    className="ci-whatsapp me-2"
                    style={{
                      marginLeft:
                        lang === "ar" || lang === "ku" ? "0.3rem" : "0",
                      marginRight:
                        lang === "ar" || lang === "ku" ? "0" : "0.3rem",
                    }}
                  />
                  {t.whatsapp}
                </button>
              </div>
            </div>

            <div className="row g-2 gmd-3">
              {filteredLinks.map((item) => {
                const href = getHref(item);

                return (
                  <div key={item.id} className="col-6 col-md-4 col-lg-4">
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-body"
                    >
                      <div
                        className="card h-100 border-0 shadow-sm"
                        style={{ borderRadius: "14px" }}
                      >
                        <div className="card-body p-2">
                          <div className="d-flex flex-column align-items-center text-center">
                            <div
                              className={`d-inline-flex align-items-center justify-content-center rounded-circle border ${item.iconClass} mb-2`}
                              style={{
                                width: 40,
                                height: 40,
                                borderColor: "#e9ecef",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                            >
                              <i
                                className={`${
                                  item.link ? item.icon : getTabIcon(activeTab)
                                }`}
                                style={{
                                  fontSize: "1rem",
                                  color: item.link
                                    ? item.iconClass === "text-danger"
                                      ? "#E4405F"
                                      : item.iconClass === "text-primary"
                                        ? "#1877F2"
                                        : "#000"
                                    : activeTab === "telegram"
                                      ? "#0088CC"
                                      : "#25D366",
                                }}
                              />
                            </div>

                            <h2
                              className="fw-medium"
                              style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.4",
                                minHeight: "auto",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {item.title}
                            </h2>

                            <div
                              className="flex items-center justify-center"
                              style={{ width: "100%" }}
                            >
                              <span
                                className={`btn btn-sm w-100 ${
                                  item.link
                                    ? "link-open-btn"
                                    : activeTab === "telegram"
                                      ? "telegram-open-btn"
                                      : "whatsapp-open-btn"
                                }`}
                                style={{
                                  fontSize: "0.72rem",
                                  padding: "0.3rem 0.4rem",
                                  borderRadius: "10px",
                                }}
                              >
                                {activeTab === "telegram"
                                  ? !item.link && (
                                      <i
                                        className="ci-telegram"
                                        style={{
                                          marginLeft:
                                            lang === "ar" || lang === "ku"
                                              ? "0.3rem"
                                              : "0",
                                          marginRight:
                                            lang === "ar" || lang === "ku"
                                              ? "0"
                                              : "0.3rem",
                                        }}
                                      />
                                    )
                                  : activeTab === "whatsapp"
                                    ? !item.link && (
                                        <i
                                          className="ci-whatsapp"
                                          style={{
                                            marginLeft:
                                              lang === "ar" || lang === "ku"
                                                ? "0.3rem"
                                                : "0",
                                            marginRight:
                                              lang === "ar" || lang === "ku"
                                                ? "0"
                                                : "0.3rem",
                                          }}
                                        />
                                      )
                                    : null}
                                {item.link ? t.openLink : t.open}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Links;
